import ModalHeader, { ModalHeaderProps } from './ModalHeader';

export type { ModalHeaderProps };
export default ModalHeader;
